import PropType from "prop-types";
/**
 * A reusable React component for rendering a modal content.
 * @param {params} props
 * @typedef {Object} params
 * @property {JSX.Element} children - The content to be displayed inside the modal content. (Required)
 * @returns {JSX.Element} The Modal Content.
 */
const ModalContent = ({ children, classes = "" }) => {
  return (
    <div
      className={`h-full max-h-[400px] overflow-y-auto p-16 scrollbar-thin scrollbar-webkit ${classes}`}
      role="modal-content"
    >
      {children}
    </div>
  );
};
ModalContent.propTypes = {
  children: PropType.node.isRequired,
  classes: PropType.string,
};

export default ModalContent;
